module.exports = __webpack_public_path__ + "img/pmb3.ffe23c45.jpg";